import $ from 'jquery';
import 'slick-carousel';


  $(document).on('click', '.accordion-link', function (e) {

    e.preventDefault();
    e.stopPropagation();

    const $link = $(this);
    const $group = $link.parents('.dsp-accordion');
    const $nav = $link.parents('.accordion-nav');

    const wasActive = $nav.hasClass('active') && $nav.data('self-collapse');

    // hide all panes in this group, deactivate all tabs
    $group.find('.accordion-pane').removeClass('show');
    $group.find('.accordion-nav').removeClass('active');
    $group.find('.accordion-nav').attr('aria-expanded', false);


    if (!wasActive) {

      // get the pane to be activated
      const $pane = $($link.attr('href'));

      // position any slider
      if ($pane.data('slider')) {
        setTimeout(() => {
          $(`.${$pane.data('slider')}`).slick('setPosition');
        }, 10);
      }
      // show this pane
      $pane.addClass('show');
      // activate this nav and link
      $link.addClass('active');
      $pane.parents('.accordion-nav').addClass('active');
      $pane.parents('.accordion-nav').attr('aria-expanded', true);
    }
  });
